function initSusCarousel() {
  console.warn('sus-carousel init started');

  const wrap = document.querySelector('.sus-carousel-module-wrap');
  if (!wrap) {
    console.warn('no .sus-carousel-module-wrap found');
    return;
  }

  const viewport = wrap.querySelector('.sus-carousel-module-viewport');
  const track = wrap.querySelector('.sus-carousel-module-track');
  const cards = wrap.querySelectorAll('.sus-carousel-module');
  const prevBtn = wrap.querySelector('.sus-carousel-module-arrow-left');
  const nextBtn = wrap.querySelector('.sus-carousel-module-arrow-right');

  if (!viewport || !track || !cards.length) {
    console.warn('carousel missing required elements', {
      viewport: !!viewport,
      track: !!track,
      cards: cards.length
    });
    return;
  }

  let currentIndex = 0;

  function getGap() {
    const styles = window.getComputedStyle(track);
    return parseInt(styles.gap || styles.columnGap || 0, 10);
  }

  function getVisibleCards() {
    const cardWidth = cards[0].offsetWidth;
    if (!cardWidth) return 1;
    return Math.max(1, Math.round((viewport.offsetWidth + getGap()) / (cardWidth + getGap())));
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCards());
  }

  function getStepSize() {
    return cards[0].offsetWidth + getGap();
  }

  function updateCarousel() {
    const maxIndex = getMaxIndex();
    const step = getStepSize();

    if (currentIndex > maxIndex) currentIndex = maxIndex;

    track.style.transform = `translateX(-${currentIndex * step}px)`;

    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
      prevBtn.classList.toggle('is-disabled', currentIndex === 0);
    }

    if (nextBtn) {
      nextBtn.disabled = currentIndex === maxIndex;
      nextBtn.classList.toggle('is-disabled', currentIndex === maxIndex);
    }

    console.warn('updateCarousel', {
      currentIndex,
      maxIndex,
      visibleCards: getVisibleCards(),
      step
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      const maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });
  }

  window.addEventListener('load', updateCarousel);
  window.addEventListener('resize', updateCarousel);

  updateCarousel();
}

//image carousels
function initSusImageCarousels() {
  document.querySelectorAll('.sus-carousel-image').forEach((carousel) => {
    const track = carousel.querySelector('.sus-carousel-image-track');
    const slides = carousel.querySelectorAll('.sus-carousel-image-slide');
    const prevBtn = carousel.querySelector('.sus-carousel-image-prev');
    const nextBtn = carousel.querySelector('.sus-carousel-image-next');

    if (!track || !slides.length || !prevBtn || !nextBtn) return;

    let currentIndex = 0;

    function updateImageCarousel() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === slides.length - 1;

      prevBtn.classList.toggle('is-disabled', currentIndex === 0);
      nextBtn.classList.toggle('is-disabled', currentIndex === slides.length - 1);
    }

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateImageCarousel();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
        updateImageCarousel();
      }
    });

    updateImageCarousel();
    window.addEventListener('resize', updateImageCarousel);
  });
}

const triggers = document.querySelectorAll('.sus-module');
const overlay = document.getElementById('susModalOverlay');
const closeBtn = document.getElementById('susModalClose');
const panels = document.querySelectorAll('.sus-modal-panel');

function openModal(panelName) {
  panels.forEach(panel => {
    panel.hidden = panel.getAttribute('data-panel') !== panelName;
  });

  overlay.hidden = false;
  document.body.classList.add('sus-modal-open');

  overlay.scrollTop = 0;

  const modal = overlay.querySelector('.sus-modal');
  if (modal) {
    modal.scrollTop = 0;
  }
}

function closeModal() {
  overlay.hidden = true;
  document.body.classList.remove('sus-modal-open');

  panels.forEach(panel => {
    panel.hidden = true;
  });
}

triggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    const panelName = trigger.getAttribute('data-popup');
    openModal(panelName);
  });
});

closeBtn.addEventListener('click', closeModal);

overlay.addEventListener('click', (e) => {
  if (e.target === overlay) {
    closeModal();
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !overlay.hidden) {
    closeModal();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSusCarousel();
    initSusImageCarousels();
  });
} else {
  initSusCarousel();
  initSusImageCarousels();
}

/*==================Sus Nav==================*/
document.addEventListener('DOMContentLoaded', function () {
  const navLinks = document.querySelectorAll('.sus-nav-link[href^="#"]');
  const sections = [];
  const sectionMap = new Map();

  let isNavJumping = false;
  let targetSectionId = null;
  let navJumpTimeout = null;

  navLinks.forEach(link => {
    const targetId = link.getAttribute('href');
    const section = document.querySelector(targetId);

    if (section) {
      sections.push(section);
      sectionMap.set(section, link);
    }
  });

  function setActiveLink(activeLink) {
    navLinks.forEach(link => {
      link.classList.toggle('is-active', link === activeLink);
    });
  }

  function getActivationOffset() {
    const siteHeader = document.querySelector('.section-header, .header, #shopify-section-header');
    const pageNav = document.querySelector('.sus-nav-holder');

    const siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;
    const pageNavHeight = pageNav ? pageNav.offsetHeight : 0;

    return siteHeaderHeight + pageNavHeight + 140;
  }

  function getCurrentSection() {
    const activationOffset = getActivationOffset();

    // Best case: section that currently spans the activation line
    for (const section of sections) {
      const rect = section.getBoundingClientRect();

      if (rect.top <= activationOffset && rect.bottom > activationOffset) {
        return section;
      }
    }

    // Fallback: closest section below the activation line
    let closestSection = sections[0] || null;
    let closestDistance = Infinity;

    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const distance = Math.abs(rect.top - activationOffset);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    });

    return closestSection;
  }

  function updateActiveNav() {
    const currentSection = getCurrentSection();
    if (!currentSection) return;

    const activeLink = sectionMap.get(currentSection);
    const activeSectionId = `#${currentSection.id}`;

    if (isNavJumping) {
      if (activeSectionId === targetSectionId) {
        isNavJumping = false;
        targetSectionId = null;
        clearTimeout(navJumpTimeout);
      } else {
        return;
      }
    }

    if (activeLink) {
      setActiveLink(activeLink);
    }
  }

  navLinks.forEach(link => {
    link.addEventListener('click', function () {
      const targetId = link.getAttribute('href');

      isNavJumping = true;
      targetSectionId = targetId;

      setActiveLink(link);

      clearTimeout(navJumpTimeout);
      navJumpTimeout = setTimeout(() => {
        isNavJumping = false;
        targetSectionId = null;
        updateActiveNav();
      }, 1400);
    });
  });

  window.addEventListener('scroll', updateActiveNav, { passive: true });
  window.addEventListener('resize', updateActiveNav);

  updateActiveNav();
});


/*---------------- Main Carousel ------------------------*/
function initSusMainCarousel() {
  const carousel = document.querySelector('.sus-main-carousel');
  if (!carousel) return;

  const track = carousel.querySelector('.sus-main-carousel-track');
  const slides = Array.from(carousel.querySelectorAll('.sus-main-carousel-slide'));
  const prevBtn = carousel.querySelector('.sus-main-carousel-prev');
  const nextBtn = carousel.querySelector('.sus-main-carousel-next');
  const dots = Array.from(carousel.querySelectorAll('.sus-main-carousel-dot'));

  if (!track || slides.length < 2) return;

  let currentIndex = 0;
  let isAnimating = false;
  let autoTimer = null;
  const duration = 450;
  const autoDelay = 5000;

  function updateDots() {
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === currentIndex);
    });
  }

  function move(direction) {
    if (isAnimating) return;
    isAnimating = true;

    const oldIndex = currentIndex;

    if (direction === 'next') {
      currentIndex = (currentIndex + 1) % slides.length;

      track.style.transition = 'transform 0.45s ease';
      track.style.transform = 'translateX(-100%)';

      setTimeout(() => {
        track.appendChild(track.firstElementChild);
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        isAnimating = false;
      }, duration);
    }

    if (direction === 'prev') {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;

      track.insertBefore(track.lastElementChild, track.firstElementChild);
      track.style.transition = 'none';
      track.style.transform = 'translateX(-100%)';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          track.style.transition = 'transform 0.45s ease';
          track.style.transform = 'translateX(0)';
        });
      });

      setTimeout(() => {
        isAnimating = false;
      }, duration);
    }

    if (oldIndex !== currentIndex) {
      updateDots();
    }
  }

  function goToSlide(targetIndex) {
    if (targetIndex === currentIndex || isAnimating) return;

    const forwardDistance = (targetIndex - currentIndex + slides.length) % slides.length;
    const backwardDistance = (currentIndex - targetIndex + slides.length) % slides.length;

    const direction = forwardDistance <= backwardDistance ? 'next' : 'prev';
    const steps = Math.min(forwardDistance, backwardDistance);

    let count = 0;

    function stepMove() {
      if (count >= steps) return;
      move(direction);
      count++;
      setTimeout(stepMove, duration + 30);
    }

    stepMove();
  }

  function resetAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(() => {
      move('next');
    }, autoDelay);
  }

  nextBtn?.addEventListener('click', () => {
    move('next');
    resetAuto();
  });

  prevBtn?.addEventListener('click', () => {
    move('prev');
    resetAuto();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      goToSlide(index);
      resetAuto();
    });
  });

  updateDots();
  resetAuto();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSusMainCarousel);
} else {
  initSusMainCarousel();
}